<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <p class="content-s-2-label" v-if="showTitle">
        <label>{{ title }}</label>
      </p>
      <table class="co-executor" style="width: 750px">
        <thead>
          <tr>
            <td>ИНН</td>
            <!-- наименование колонки совпадает с наименованием пункта: «Производитель судна» / «Оператор судна» -->
            <td>{{ title }}</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              v-bind:class="{
                'has-error': hasError('UF_OGRN')
              }"
            >
              <input type="hidden" v-model="row.ID" />
              <input type="hidden" v-model="row.UF_COMPANY_ID" />
              {{ row.UF_INN }}
              <div class="error-text">{{ errorText("UF_OGRN") }}</div>
            </td>
            <td
              v-bind:class="{
                'has-error': hasError('UF_NAME')
              }"
            >
              {{ row.UF_NAME }}
              <div class="error-text">{{ errorText("UF_NAME") }}</div>
            </td>
            <td>
              <a
                v-if="isCompanySelected && !$parent.$parent.projectDisabled"
                v-on:click="clearRow"
                class="link-delete-row"
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="add-row"
        v-show="!isCompanySelected && !$parent.$parent.projectDisabled"
      >
        <a class="link-add-row" @click="showSearchOrg = true">{{
          addLabel
        }}</a>
      </div>
    </div>

    <!-- Поиск организации по ИНН/ОГРН/названию -->
    <div
      class="modal fade in"
      v-bind:class="{ show: showSearchOrg }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="closeSearch"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ title }}</h4>
          </div>
          <div class="modal-body">
            <p class="select-blue-desc">
              Начните вводить Название или ИНН/Регистрационный номер контрагента,
              затем выберите нужный из списка. Если ничего не найдено, добавьте
              нового контрагента, нажав на '+'
            </p>
            <div class="form-group">
              <div class="form-group add-row autocomplete-form-add">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <v-autocomplete
                          :items="orgsList"
                          input-class="form-control"
                          :auto-select-one-item="false"
                          :keep-open="false"
                          :component-item="act"
                          v-model="selectedOrg"
                          ref="autoSearchInputRef"
                          :min-len="3"
                          :get-label="getLabel"
                          placeholder="Название или ИНН/Идентификационный код контрагента"
                          @update-items="searchOrg"
                          @change="isSearchGood = true"
                          @input="selectSearchItems"
                        ></v-autocomplete>
                      </td>
                      <td class="button-del" v-if="selectedOrg">
                        <a @click="clearAutocomplete" class="link-delete-row"></a>
                      </td>
                      <td class="button-del" v-else-if="!isSearchGood">
                        <a @click="resetAutocomplete" class="link-delete-row"></a>
                      </td>
                      <td class="button-add">
                        <a
                          class="link-add-row"
                          style="width: 20px; padding: 0;"
                          :href="getLinkOlk()"
                          title="Добавить контрагента"
                          target="_blank"
                        ></a>
                      </td>
                    </tr>
                    <tr v-if="!isSearchGood">
                      <td colspan="2">
                        <p style="text-align: left; font-style: italic;">
                          По вашему запросу ничего не найдено, попробуйте
                          изменить запрос
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addOrg"
              :disabled="!isAddOrgGood"
              type="button"
              class="btn btn-primary"
            >
              {{ addLabel }}
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="closeSearch"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import Item from "@/components/expert/Item.vue";

export default {
  name: "ship_company",
  props: {
    // SHIP_MANUFACTURER либо SHIP_OPERATOR
    modelKey: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    // подпись над таблицей: не нужна, когда наименование вынесено в заголовок пункта
    // (в заголовке модального окна поиска организации title используется всегда)
    showTitle: {
      type: Boolean,
      default: true
    },
    // подпись ссылки под таблицей и кнопки в окне поиска организации
    addLabel: {
      type: String,
      default: "Добавить организацию"
    },
    // имя контейнера ошибок в Edit.vue
    errorsKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showSearchOrg: false,
      selectedOrg: "",
      orgsList: [],
      act: Item,
      isSearchGood: true,
      isAddOrgGood: false
    };
  },
  computed: {
    ...mapGetters(["project"]),
    row() {
      const model = this.project[this.modelKey];
      return model && Array.isArray(model.items) && model.items.length
        ? model.items[0]
        : {};
    },
    isCompanySelected() {
      return !!(this.row.UF_NAME || this.row.UF_OGRN || this.row.UF_INN);
    }
  },
  created() {
    this.ensureRow();
  },
  methods: {
    ensureRow() {
      const model = this.project[this.modelKey];
      // таблица всегда состоит из одной строки, добавление строк не предусмотрено
      if (!model || !Array.isArray(model.items)) {
        Vue.set(this.project, this.modelKey, { items: [] });
      }
      if (this.project[this.modelKey].items.length === 0) {
        this.project[this.modelKey].items.push({
          ID: 0,
          UF_OGRN: "",
          UF_INN: "",
          UF_COMPANY_ID: 0,
          UF_NAME: ""
        });
      }
    },
    searchOrg(query) {
      this.isSearchGood = true;
      if (query !== undefined) {
        ProjectsService.getFindOrgByGetWay({ search: query }).then(
          ({ data }) => {
            this.orgsList = data.items;
            this.isSearchGood = this.orgsList.length > 0;
          }
        );
      }
    },
    addOrg() {
      if (!this.isAddOrgGood) {
        return;
      }
      const counterparty = this.selectedOrg.counterparty;

      this.removeError("UF_OGRN");
      this.removeError("UF_NAME");

      // ИП идентифицируется ОГРНИП и полным наименованием
      Vue.set(this.row, "UF_OGRN", counterparty.ogrnIp || counterparty.ogrn);
      Vue.set(this.row, "UF_INN", counterparty.inn);
      Vue.set(
        this.row,
        "UF_NAME",
        counterparty.ogrnIp ? counterparty.fullName : counterparty.shortName
      );
      Vue.set(this.row, "UF_COMPANY_ID", 0);
      // организацию по данным ОЛК заводит бэк при сохранении
      Vue.set(this.row, "DATA_OLK", this.selectedOrg);

      this.closeSearch();
    },
    clearRow() {
      this.removeError("UF_OGRN");
      this.removeError("UF_NAME");
      Vue.set(this.row, "UF_OGRN", "");
      Vue.set(this.row, "UF_INN", "");
      Vue.set(this.row, "UF_NAME", "");
      Vue.set(this.row, "UF_COMPANY_ID", 0);
      Vue.delete(this.row, "DATA_OLK");
    },
    closeSearch() {
      this.showSearchOrg = false;
      this.clearAutocomplete();
      this.resetAutocomplete();
    },
    clearAutocomplete() {
      this.selectedOrg = null;
      this.orgsList = [];
      this.isAddOrgGood = false;
    },
    resetAutocomplete() {
      if (this.$refs.autoSearchInputRef) {
        this.$refs.autoSearchInputRef.searchText = "";
      }
      this.selectedOrg = null;
      this.isAddOrgGood = false;
      this.isSearchGood = true;
    },
    selectSearchItems() {
      this.isAddOrgGood = !!(this.selectedOrg && this.selectedOrg.id !== "");
    },
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
      }
    },
    getLinkOlk() {
      const meta = this.project.META;
      return meta && meta.OLK_COUNTERPARTY_PAGE
        ? meta.OLK_COUNTERPARTY_PAGE
        : "https://olk.frprf.ru/counterparty/";
    },
    // Строка одна, поэтому номер строки из ответа бэка не проверяем
    hasError(field) {
      return this.errorText(field) !== "";
    },
    errorText(field) {
      const errors = this.$parent.$parent[this.errorsKey] || {};
      const row = Object.keys(errors).find(
        key => errors[key] && typeof errors[key][field] !== "undefined"
      );
      return row === undefined ? "" : errors[row][field];
    },
    removeError(field) {
      const errors = this.$parent.$parent[this.errorsKey] || {};
      Object.keys(errors).forEach(function(key) {
        if (errors[key] && typeof errors[key][field] !== "undefined") {
          Vue.delete(errors[key], field);
        }
      });
    }
  }
};
</script>

<style scoped></style>
